import { Globe, Users, Shield, TrendingUp } from "lucide-react";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-background pt-24 px-4 lg:px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-foreground mb-6">
          About BUYFIAT
        </h1>

        <div className="nex-card p-8 mb-8">
          <p className="text-lg text-muted-foreground leading-relaxed mb-6">
            BUYFIAT is Africa's premier cryptocurrency exchange and P2P trading
            platform. We provide a secure, fast, and reliable way for Africans
            to trade cryptocurrencies and exchange local currencies across
            borders.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Founded with a mission to democratize access to digital assets,
            BUYFIAT combines cutting-edge blockchain technology with deep
            understanding of African markets to deliver an unparalleled trading
            experience.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {[
            {
              icon: Globe,
              title: "5 Countries",
              desc: "Operating across Nigeria, Ghana, Kenya, South Africa, and Egypt",
            },
            {
              icon: Users,
              title: "2M+ Users",
              desc: "Trusted by millions of traders across Africa",
            },
            {
              icon: Shield,
              title: "Bank-Grade Security",
              desc: "Your assets are protected with industry-leading security",
            },
            {
              icon: TrendingUp,
              title: "$12B+ Volume",
              desc: "Monthly trading volume across all markets",
            },
          ].map((stat, i) => (
            <div key={i} className="nex-card p-6">
              <stat.icon className="w-8 h-8 text-primary mb-4" />
              <h3 className="text-xl font-semibold text-foreground mb-2">
                {stat.title}
              </h3>
              <p className="text-sm text-muted-foreground">{stat.desc}</p>
            </div>
          ))}
        </div>

        <div className="nex-card p-8">
          <h2 className="text-xl font-semibold text-foreground mb-4">
            Our Mission
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            To empower Africans with seamless access to the global digital
            economy through innovative financial technology solutions that are
            secure, affordable, and tailored to local needs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
